import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteUpdateFulfilmentAgent } from "../../../data/usecases/remote-update-fulfilment-agent";
import { UpdateFulfilment } from "../../../domain/models/update-fulfilment";
import Swal from "sweetalert2";
import { UpdateUserManagementData } from "../../../domain/useages/user-management/update-user-management-data";
import { RemoteUpdateUserManagementData } from "../../../data/usecases/user-management/remote-update-user-management-data";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface UpdateUserManagementDataInterface {
  updateUserManagementData: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useUpdateUserManagementDataSlice: StateCreator<
  UpdateUserManagementDataInterface
> = (set, get) => ({
  updateUserManagementData: async (
    id: number,
    payload: UpdateUserManagementData.Params,
    handleClose: Function
  ) => {
      const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
      const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteUpdateUserManagementData = new RemoteUpdateUserManagementData(
      `${BASE_URL}${Endpoints.UPDATE_USER_MANAGEMENT_DATA}`,
      axiosHttpClient
    );
    let result = await remoteUpdateUserManagementData.edit(
      id.toString(),
      payload
    );

    if (result) {
      handleClose();
    }
  },
});
